// @flow
import React, { PureComponent, Fragment } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { withProps } from './../../routes';
import PageDetail from 'containers/page/PageDetailContainer';

import type { Match } from 'react-router-dom';

type Props = {
  subroutes: Object[],
  match: Match
};

// essai pour améliorer les perf
// https://www.codementor.io/blog/react-optimization-5wiwjnf9hj#2-functionstateless-components-and-reactpurecomponent
// engendre une boucle infinie de fetch des données de PageDetail
// https://www.codementor.io/blog/react-optimization-5wiwjnf9hj#9-avoid-using-index-as-key-for-map
class SubRouter extends PureComponent<Props> {
  renderRoute = () => {
    const { subroutes, match } = this.props;
    const url = match.url.replace(/\/$/, '');

    return subroutes.map<any>((route, index) => {
      if (route.object_slug !== '') {
        if (index === 0) {
          return (
            <Fragment key={route.object_slug}>
              <Route exact path={`${url}/`} component={withProps({ to: `${url}/${route.object_slug}` })(Redirect)} />

              <Route
                path={`${match.url}/${route.object_slug}`}
                component={withProps({ pageSlug: route.object_slug })(PageDetail)}
              />
            </Fragment>
          );
        }

        return (
          <Route
            key={route.object_slug}
            path={`${match.url}/${route.object_slug}`}
            component={withProps({ pageSlug: route.object_slug })(PageDetail)}
          />
        );
      }
      return null;
    });
  };

  render() {
    return <>{this.renderRoute()}</>;
  }
}

export default SubRouter;
